import { AutogenLayoutCallListProfileList } from "./autogen/AutogenLayoutCallListProfileList";

export class CallListProfileList extends AutogenLayoutCallListProfileList {
    onLoad(): void | Promise<void> {
        this.tableCallListProfiles.addButtonCaption = "Add Call List Profile";
    }
}